import { SelectOption } from '../../catalogs/catalogs.model';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-tab-panes',
  templateUrl: './tab-panes.component.html',
  styleUrls: ['./tab-panes.component.scss']
})
export class TabPanesComponent {
  @Input() current: string;
  @Input() tabs: SelectOption[];
  @Output() tabChange = new EventEmitter<string>();

  handleTabChange(value) {
    this.tabChange.emit(value);
  }
}
